import { render, staticRenderFns } from "./qkinfo.vue?vue&type=template&id=d7c36cda&scoped=true"
import script from "./qkinfo.vue?vue&type=script&lang=js"
export * from "./qkinfo.vue?vue&type=script&lang=js"
import style0 from "./qkinfo.vue?vue&type=style&index=0&id=d7c36cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c36cda",
  null
  
)

export default component.exports